import { render } from "./SetData.vue?vue&type=template&id=11d71ea7"
import script from "./SetData.vue?vue&type=script&lang=js"
export * from "./SetData.vue?vue&type=script&lang=js"

import "./SetData.vue?vue&type=style&index=0&id=11d71ea7&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__